var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1761 19.3546L13.9064 10.0724C13.9063 10.0724 13.9062 10.0723 13.9062 10.0722L13.9061 10.0721L23.1761 19.3546ZM23.1761 19.3546L13.3897 28.9195C13.3896 28.9195 13.3896 28.9196 13.3895 28.9197C13.2825 29.0236 13.1974 29.148 13.1393 29.2855C13.0811 29.423 13.0512 29.5708 13.0512 29.7201C13.0512 29.8694 13.0811 30.0172 13.1393 30.1547C13.1974 30.2922 13.2826 30.4167 13.3897 30.5207L13.3897 30.5207L13.39 30.521C13.6077 30.7312 13.8985 30.8487 14.2012 30.8487C14.5038 30.8487 14.7947 30.7312 15.0124 30.521L15.0124 30.521L15.013 30.5204L25.612 20.1678C25.6121 20.1677 25.6122 20.1676 25.6123 20.1675C25.7186 20.0644 25.8034 19.941 25.8616 19.8047C25.9199 19.6683 25.9503 19.5216 25.9512 19.3733C25.9521 19.2249 25.9235 19.0779 25.8669 18.9408C25.8103 18.8038 25.7271 18.6795 25.622 18.575C25.6219 18.5749 25.6218 18.5748 25.6217 18.5747L15.5519 8.4909L15.5516 8.49059C15.3364 8.27639 15.0462 8.15454 14.7426 8.15094C14.439 8.14734 14.1459 8.26227 13.9257 8.47131C13.8174 8.57401 13.7307 8.69739 13.6709 8.83417C13.6111 8.97099 13.5794 9.11842 13.5776 9.26773C13.5757 9.41704 13.6039 9.56519 13.6604 9.70342L13.7993 9.64668L23.1761 19.3546Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.987824befb51d39e057549c1054f39d1.svg";
export { ForwardRef as ReactComponent };